import type { ADFEntity } from '@atlaskit/adf-utils/types';

import type { BlocksSnippetAri } from '@atlassian/ari';

export enum SnippetProduct {
	// Only Confluence is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	CONFLUENCE = 'CONFLUENCE',
}
export enum SnippetBodyFormat {
	// Only ADF is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	ADF = 'ADF',
}

export enum SnippetStatus {
	ACTIVE = 'active',
	DELETED = 'deleted',
}

export const ATLASSIAN_ACCOUNT_ID = 'atlassian' as const;

export type SnippetOwner =
	| {
			accountId: string;
			displayName: string;
	  }
	| {
			accountId: typeof ATLASSIAN_ACCOUNT_ID;
			displayName: 'Atlassian';
	  };

// Transformed snippet data from the block service
export type Snippet = {
	ari: BlocksSnippetAri;
	snippetId: string; // uuidv7
	name: string;
	description?: string;
	bodyFormat: SnippetBodyFormat;
	body: ADFEntity | ADFEntity[];
	product: SnippetProduct;
	label?: string;
	isFavorite: boolean;
	status: SnippetStatus;
	createdBy: SnippetOwner;
	createdAt: Date;
	updatedAt: Date;
};
